<div class="noteItem">
    <div class="noteheader">{{caseNote.addedDateTime  | date:'dd/MM/yyyy HH:mm'}}  - {{caseNote.addedBy.firstName}} {{caseNote.addedBy.lastName}}
      <fa-icon *ngIf="caseNote.internalNote" [icon]="faLockAlt" ></fa-icon>
    </div>
    <div class="notebody" style="font-size:14px;">
      {{caseNote.notes}}
    </div>
  </div>
